<template>
    <vue-final-modal classes="modal-container" scrollable="true" :focus-retain="true" :focus-trap="true"
        v-slot="{ close }" :max-width="1024" :fit-parent="false" :esc-to-close="true">
        <div class="u-mrg-sides u-padd-top u-mrg-center" style="overflow-y: auto; height: 100%;">


            <div v-if="state === 'alreadyLoggedIn'">
                <p>You are already logged in.</p>
                <div class="u-mrg-top-half flex-button-bar">
                    <button class="btn btn--primary" @click="close">Close</button>
                    <button class="btn btn--secondary" @click="() => signOut(close)">Sign Out</button>
                </div>
            </div>

            <div class="account-login" v-if="state === 'login'">
                <account-login :is-modal="true" :account-sign-in-title="accountSignInTitle"
                    :account-sign-in-error="accountSignInError" :account-sign-in-cta="accountSignInCta"
                    :account-create-account-title="accountCreateAccountTitle"
                    :account-create-account-copy="accountCreateAccountCopy"
                    :account-create-account-cta="accountCreateAccountCta"
                    @userAction="(action) => userActionHandler('login', action, close)">
                </account-login>
            </div>

            <div class="create-account" v-if="state === 'create'">
                <create-account :is-modal="true" :tool-name="toolName" :captcha-key="captchaKey"
                    :create-account-title="createAccountTitle" :create-account-subhead="createAccountSubhead"
                    :create-account-content="createAccountContent" :terms-link="termsLink"
                    :create-account-cta="createAccountCta" :data-url="dataUrl" :customer-types="customerTypes"
                    @userAction="(action) => userActionHandler('create', action, close)">
                </create-account>
            </div>

            <div class="forget-password max-width-md u-mrg-center" v-if="state === 'forgot'">
                <forgot-password :is-modal="true" :forgot-password-title="forgotPasswordTitle"
                    :forgot-password-subhead="forgotPasswordSubhead" :forgot-password-cta="forgotPasswordCta"
                    :forgot-password-subhead-success="forgotPasswordSubheadSuccess"
                    :forgot-password-cta-success="forgotPasswordCtaSuccess"
                    @userAction="(action) => userActionHandler('forgot', action, close)">
                </forgot-password>
            </div>


            <div @click="close" title="Close (Esc)" type="" class="modal-close cursor-pointer" role="button"
                tabindex="0"></div>

        </div>
    </vue-final-modal>
</template>

<style scoped></style>

<script>
import { VueFinalModal } from "vue-final-modal";
import AccountLogin from "./AccountLogin.vue";
import CreateAccount from './CreateAccount.vue';
import ForgotPassword from "./ForgotPassword.vue";
import simpleUserApi from "../../utils/api/simpleUserApi";
export default {
    props: {
        //common props
        captchaKey: {
            type: String,
            default: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' //debug test site key
        },
        termsLink: {
            type: String,
            default: '/terms'
        },
        dataUrl: {
            type: String,
            default: '/site-api/reps/legacy-country-state-county'
        },
        accountLoginUrl: {
            type: String,
            default: '/account/account-login'
        },
        toolName: {
            type: String,
            default: 'not-set'
        },

        // Create account props
        createAccountTitle: {
            type: String,
            default: 'Create an Account'
        },
        createAccountSubhead: {
            type: String,
            default: '<p>The best way to experience our Water Quality Design Tool is to create an account.</p><p>When you create an account, your VIP access allows you to:</p>'
        },
        createAccountContent: {
            type: String,
            default: '<ul><li>Get both a project specific PDF and DWG file emailed to you for every project</li></ul><ul><li>Utilize all aspects of this tool including enhanced layouts and calculators</li></ul><ul><li>Enjoy a cloud-based workplace to save and edit project layouts</li></ul><ul><li>Store previously save projects to reference as needed</li></ul>'
        },
        createAccountCta: {
            type: String,
            default: 'Register for account'
        },
        customerTypes: {
            type: Array,
            default: () => ['Distributor', 'Government', 'Contractor', "Engineer"]
        },

        //login props
        accountSignInTitle: {
            type: String,
            default: 'Sign in'
        },
        accountSignInError: {
            type: String,
            default: '*Are you sure you have an account with us?'
        },
        accountSignInCta: {
            type: String,
            default: 'Sign in'
        },
        accountCreateAccountTitle: {
            type: String,
            default: 'Create an Account'
        },
        accountCreateAccountCopy: {
            type: String,
            default: 'To save your Water Quality or Nyloplast project, create an account.'
        },
        accountCreateAccountCta: {
            type: String,
            default: 'Join Now'
        },
        // Thank you props
        thankYouTitle: {
            type: String,
            default: 'Thank you for creating an account.'
        },
        thankYouCta: {
            type: String,
            default: 'Login'
        },

        //ForgotPasswordModal props
        forgotPasswordTitle: {
            type:String,
            default:"Forgot your Password?"
        },
        forgotPasswordSubhead: {
            type: String,
            default: "Provide your email and we'll send you a password rest link to the account on file."
        },
        forgotPasswordCta: {
            type: String,
            default: "Reset My Password"
        },
        forgotPasswordSubheadSuccess: {
            type: String,
            default: "Please check your email for a password reset link."
        },
        forgotPasswordCtaSuccess: {
            type: String,
            default: "Sign in"
        },
    },
    components: {
        VueFinalModal,
        AccountLogin,
        CreateAccount,
        ForgotPassword
    },
    methods: {
        userActionHandler(context, action, close) {
            console.log(`SignInDialog action hander: ${context}:${action}`);
            switch (action) {
                case "loggedIn":
                    close();
                    break;
                case "login":
                    this.state = 'login';
                    break;
                case "accountCreated":
                    this.state = 'login';
                    break;
                case "create":
                    this.state = 'create';
                    break;
                case "forgot":
                    this.state = 'forgot';
                    break;
                case "cancel":
                    close();
                    break;
            }
        },
        async signOut(close) {
            await simpleUserApi.logout();
            close();
        }
    },
    data() {
        return {
            state: 'loading'
        }
    },
    async mounted() {
        const authState = await simpleUserApi.isUserAuthenticated();
        if (authState.success) {
            this.state = 'alreadyLoggedIn';
        } else {
            this.state = 'login';
        }
    }
};
</script>